import React, { useState, useEffect } from 'react';
import { updateChat, fetchStaff, deleteChat } from '../utils/api';
import './_Modal.css';

const EditGroupChatModal = ({ isOpen, onClose, user, chat, onChatUpdated }) => {
    const [chatName, setChatName] = useState('');
    const [error, setError] = useState('');
    const [allStaff, setAllStaff] = useState([]);
    const [selectedMembers, setSelectedMembers] = useState([]);

    useEffect(() => {
        if (isOpen && chat) {
            setChatName(chat.name);
            
            const memberIDs = chat.members.map(m => m.id);
            
            fetchStaff().then(response => {
                const staff = response.data;
                setAllStaff(staff);
                const currentMembers = staff.filter(s => memberIDs.includes(s.id));
                setSelectedMembers(currentMembers);
            }).catch(err => {
                setError('Failed to fetch users.');
            });
        }
    }, [isOpen, chat]);

    const handleUpdateChat = () => {
        if (!chatName.trim()) {
            setError('Chat name is required.');
            return;
        }

        const memberIds = selectedMembers.map(m => m.id);
        if (memberIds.length < 2) {
            setError('Group chats must have at least 2 members.');
            return;
        }

        updateChat(chat.id, { name: chatName, member_ids: memberIds }).then(() => {
            onChatUpdated();
            onClose();
        }).catch(err => {
            setError('Failed to update chat.');
        });
    };

    const handleDeleteChat = () => {
        deleteChat(chat.id).then(() => {
            onChatUpdated();
            onClose();
        }).catch(err => {
            setError('Failed to delete chat.');
        });
    };

    const handleAddMember = (staffId) => {
        const staffToAdd = allStaff.find(s => s.id === parseInt(staffId));
        if (staffToAdd && !selectedMembers.some(s => s.id === staffToAdd.id)) {
            setSelectedMembers([...selectedMembers, staffToAdd]);
        }
    };

    const handleRemoveMember = (staffId) => {
        if (staffId === user.id) {
            return;
        }
        setSelectedMembers(selectedMembers.filter(s => s.id !== staffId));
    };

    if (!isOpen) {
        return null;
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Edit Group Chat</h2>
                {error && <p className="error">{error}</p>}
                <div className="form-group">
                    <label>Chat Name</label>
                    <input
                        type="text"
                        value={chatName}
                        onChange={(e) => setChatName(e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label>Members</label>
                    <select onChange={(e) => handleAddMember(e.target.value)} defaultValue="">
                        <option value="" disabled>Select a staff member to add</option>
                        {allStaff.filter(s => !selectedMembers.some(sm => sm.id === s.id)).map(s => (
                            <option key={s.id} value={s.id}>
                                {s.first_name} {s.last_name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="selected-staff-container">
                    {selectedMembers.map(member => (
                        <div key={member.id} className="selected-staff-member">
                            {member.first_name} {member.last_name}
                            {member.id !== user.id && <button onClick={() => handleRemoveMember(member.id)}>x</button>}
                        </div>
                    ))}
                </div>

                <div className="actions-centered">
                    <button className="text-button cancel-button" onClick={onClose}>Cancel</button>
                    <button className="text-button submit-button" onClick={handleDeleteChat}>Delete Chat</button>
                    <button className="text-button submit-button" onClick={handleUpdateChat}>Save Changes</button>
                </div>
            </div>
        </div>
    );
};

export default EditGroupChatModal;
